import { FormWrapper, UploadInput } from 'components/form';
import { useTranslation } from 'react-i18next';
import ClaimCardWrapper from 'components/claimCard/ClaimCardWrapper';

interface DocumentsCard {
  stepIndex?: number;
}

const DocumentsCard = ({ stepIndex = 1 }: DocumentsCard) => {
  const { t } = useTranslation();

  return (
    <ClaimCardWrapper id="documents" header="newClaim.supplementaryDocuments.title" stepIndex={stepIndex}>
      <FormWrapper
        name="admissionOrReferralLetters"
        optionalText={t('common.optional')}
        label={t('preAuthRequest.supplementaryDocuments.documentDescription')}
      >
        <UploadInput name="admissionOrReferralLetters" />
      </FormWrapper>
    </ClaimCardWrapper>
  );
};

export default DocumentsCard;
